"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtilsLessonSlide = void 0;
var enums_1 = require("./enums");
var UtilsLessonSlide = /** @class */function () {
  function UtilsLessonSlide() {}
  /**
   * Возвращает конфигурацию области просмотра исходя из возможностей устройства
   */
  UtilsLessonSlide.configureViewport = function (baseWidth, baseHeight, cellOffset, slide) {
    var _maxWidth = baseWidth;
    var _maxHeight = baseHeight * slide.height_ratio;
    var _a = this.cellSize(slide, _maxWidth, _maxHeight, cellOffset),
      cellWidth = _a.cellWidth,
      cellHeight = _a.cellHeight;
    return {
      gridWidth: slide.columns * cellWidth + (slide.columns - 1) * cellOffset + 2,
      gridHeight: _maxHeight,
      cellWidth: cellWidth,
      cellHeight: cellHeight,
      cellOffset: cellOffset,
      imageSizes: ['md']
    };
  };
  /**
   * Возвращает размер ячеек таблицы исходя из размеров поля и количества строк/колонок
   */
  UtilsLessonSlide.cellSize = function (slide, viewportWidth, viewportHeight, cellOffset) {
    if (!slide.rows || !slide.columns) {
      return {
        cellHeight: 0,
        cellWidth: 0
      };
    }
    var maxHeight = Math.round((viewportHeight - (slide.rows - 1) * cellOffset) / slide.rows);
    var maxWidth = Math.round((viewportWidth - (slide.columns - 1) * cellOffset) / slide.columns);
    switch (slide.aspect_ratio) {
      case enums_1.LessonSlideImageAspectRatioEnum.wide:
        if (maxHeight < maxWidth / 4) {
          return {
            cellHeight: maxHeight,
            cellWidth: maxHeight * 4
          };
        } else {
          return {
            cellWidth: maxWidth,
            cellHeight: Math.round(maxWidth / 4)
          };
        }
      case enums_1.LessonSlideImageAspectRatioEnum.horizontal:
        if (maxHeight < maxWidth / 2) {
          return {
            cellHeight: maxHeight,
            cellWidth: maxHeight * 2
          };
        } else {
          return {
            cellWidth: maxWidth,
            cellHeight: Math.round(maxWidth / 2)
          };
        }
      case enums_1.LessonSlideImageAspectRatioEnum.square:
        var s = Math.min(maxHeight, maxWidth);
        return {
          cellHeight: s,
          cellWidth: s
        };
      case enums_1.LessonSlideImageAspectRatioEnum.vertical:
        if (maxWidth < maxHeight / 2) {
          return {
            cellWidth: maxWidth,
            cellHeight: maxWidth * 2
          };
        } else {
          return {
            cellHeight: maxHeight,
            cellWidth: Math.round(maxHeight / 2)
          };
        }
    }
  };
  return UtilsLessonSlide;
}();
exports.UtilsLessonSlide = UtilsLessonSlide;
